/** @jsx jsx */

import { jsx } from '@emotion/core';
import Edit from 'assets/edit.svg';

const EditMarker = ({ style = {} }) => {
  return (
    <div
      className="chameleon-edit-marker"
      style={{
        position: 'absolute',
        right: 0,
        top: 0,
        width: 16,
        height: 16,
        margin: 0,
        padding: 0,
        background: `url(${Edit}) no-repeat`,
        ...style,
      }}
    />
  );
};

export default EditMarker;
